<!--Header-->
<div class="modal-header text-center" style="color: white;background-color: #544d84">    
    <h4 class="modal-title w-100">{{x_titulo}}</h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onClosemodal()">
      <span aria-hidden="true" class="white-text">&times;</span>
    </button>
</div>
  
<!--Body-->
<div class="modal-body">

  <mdb-card>
    <mdb-card-body>

      <div class="form-row">
        <div class="col-3">Código:</div>
        <div class="col-9">
            {{id}}
        </div>
      </div>
      <br>
      <div class="form-row">
        <div class="col-3">Titulo:</div>
        <div class="col-9">                
          <!--daet-->
          <!--input mdbInput type="text" maxlength="200"  class="form-control" [(ngModel)]="txtTitle" disabled-->
          <input mdbInput type="text" maxlength="200"  class="form-control" [(ngModel)]="txtTitle">
        </div>
      </div>
      <br>
      <div class="form-row">
        <div class="col-3">Código de Producto:</div>
        <div class="col-9">                
          <input mdbInput type="text" maxlength="200"  class="form-control" [(ngModel)]="txtCodigoProducto" >
        </div>
      </div>
      <br>
      <div class="form-row">
        <div class="col-3">Categoria:</div>
        <div class="col-9">                
          <input mdbInput type="text" maxlength="200"  class="form-control" [(ngModel)]="txtCategoria" disabled >
        </div>
      </div>
      <br>
      <div class="form-row">
        <div class="col-3">Sub Categoria:</div>
        <div class="col-9">                
          <input mdbInput type="text" maxlength="200"  class="form-control" [(ngModel)]="txtSubCategoria" disabled>
        </div>
      </div>
      <br>
      <!--daet ini-->
      <div class="form-row">
        <div class="col-3">Descripción Web:</div>
        <div class="col-9">                
          <textarea  maxlength="200"  class="form-control" [(ngModel)]="txtDescriptionE" rows="4"></textarea>
        </div>
      </div>
      <!--daet fin-->
      <div class="form-row">
        <div class="col-3">Descripción:</div>
        <div class="col-9">                
          <textarea  maxlength="200"  class="form-control" [(ngModel)]="txtDescription" disabled rows="4"></textarea>
        </div>
      </div>
      <br>
      <div class="form-row">
        <div class="col-3">Autor:</div>
        <div class="col-9">                
          <input mdbInput type="text" maxlength="200"  class="form-control" [(ngModel)]="txtAutor" disabled>
        </div>
      </div>
      <br>
      <div class="form-row">
        <div class="col-3">Tag:</div>
        <div class="col-9">        
          <!--daet-->
          <!--textarea  maxlength="200"  class="form-control" [(ngModel)]="txtTag" disabled rows="4"></textarea-->
          <textarea  maxlength="200"  class="form-control" [(ngModel)]="txtTag" rows="4"></textarea>
        </div>
      </div>
      <br>      
      <div class="form-row">
        <div class="col-3">Estado:</div>
        <div class="col-9">                
            <select class="browser-default custom-select" [(ngModel)]="cboEnabled">
                <option value="" selected>Seleccione</option>
                <option *ngFor="let estado of listEstado.response.list" [value]="estado.masterName">{{estado.masterDescription}}</option>
            </select>
        </div>
      </div>
      <br>      
    </mdb-card-body>
  </mdb-card>
  <br>
  <div class="form-row">
    <div class="col-12">
      <mdb-card>
        <mdb-card-body>
          <div class="form-row">
            <div class="col-3">Modalidad:</div>
            <div class="col-9">                
              <select class="browser-default custom-select" [(ngModel)]="cboModalidad">
                <option value="" selected>Seleccione</option>
                <option *ngFor="let modalidad of listModalidad.response.list" [value]="modalidad.id">{{modalidad.name}}</option>
            </select>
            </div>
          </div>
          <br>
          <div class="form-row">
            <div class="col-3">Precio:</div>
            <div class="col-9">                
              <input mdbInput type="number" maxlength="200"  class="form-control" [(ngModel)]="txtPrecio">

            </div>
          </div>
          <br>

          <button mdbBtn type="button" (click)="onAgregarModalidad()" size="sm" class="btn btn-deep-purple btn-rounded" mdbWavesEffect>Agregar Modalidad</button>
          <div class="table-responsive text-nowrap">
            <table class="w-100" mdbTable hover="true">
              <thead>
                <tr>
                  <th *ngFor="let head of headModalidad" scope="col">{{head}}</th>
                </tr>
              </thead>
              <tbody>
                <tr mdbTableCol *ngFor="let modalidad of listModalidadBean;let i = index">
                  <th>{{i + 1}}</th>
                  <th>{{modalidad.name}}</th>
                  <th>{{modalidad.price}}</th>
                  <td><button type="button" color="link" (click)="onDeleteModalidad(modalidad)" class="btn-sm" mdbWavesEffect mdbBtn><mdb-icon fas icon="minus-square" size="2x" class="indigo-text pr-3"></mdb-icon></button></td>
                </tr>
              </tbody>
            </table>
          </div>
        </mdb-card-body>
      </mdb-card>
    </div>
  </div>
  <br>
  <br>  
  <mdb-card>
    <mdb-card-body>
        <div class="form-row">
          <div class="col-12">
            <div class="text-center">
              <span style="display: block;">Imagen Actual</span><br>

              <!-- Mostrar skeleton mientras carga -->
              <div *ngIf="isLoadingImage" class="skeleton-container" style="display: inline-block; width: auto; height: 400px;">
                <app-image-skeleton
                  width="300px"
                  height="400px"
                  size="large">
                </app-image-skeleton>
              </div>

              <!-- Mostrar imagen protegida si está disponible -->
              <img *ngIf="!isLoadingImage && protectedImageUrl"
                   [src]="protectedImageUrl"
                   alt="Imagen protegida"
                   class="img-thumbnail"
                   style="height: 400px;">

              <!-- Fallback: mostrar imagen sin protección si no hay activoId -->
              <img *ngIf="!isLoadingImage && !protectedImageUrl && x_url"
                   [src]="x_url"
                   alt="Imagen sin protección"
                   class="img-thumbnail"
                   style="height: 400px;">

              <!-- Mensaje si no hay imagen -->
              <div *ngIf="!isLoadingImage && !protectedImageUrl && !x_url"
                   style="height: 400px; display: flex; align-items: center; justify-content: center; border: 1px solid #ddd; border-radius: 4px;">
                <span class="text-muted">Sin imagen</span>
              </div>
            </div>
          </div>
        </div>
    </mdb-card-body>
  </mdb-card>    
  <br>
  <!--Footer-->
<div class="modal-footer justify-content-center">
    <button mdbBtn type="button" (click)="onGrabar()" size="sm" class="btn btn-deep-purple btn-rounded" mdbWavesEffect>
        <mdb-icon fas icon="save" class="mr-1"></mdb-icon>Grabar</button>
</div>
